<template>
  <div class="text-stats" :class="{'-has-error': error}">
    <h2 class="title">{{ title }} <span class="errorMessage" v-if="error">Erro</span></h2>

    <div class="itemsArea">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextStats',

  props: {
    title: {
      required: true,
      type: String,
    },

    error: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-stats {
  @apply flex;
  @apply flex-col;
  @apply gap-4;
  @apply text-secondary-700;
  @apply text-sm;

  > .title {
    @apply w-full;
    @apply flex-1;
    @apply pb-4;
    @apply text-secondary-700;
    @apply uppercase;
    @apply text-sm;
    @apply font-bold;
    letter-spacing: .05em;
  }

  > .itemsArea {
    @apply w-full;
    @apply gap-8;
    @apply flex;
    @apply flex-col;
    @apply pb-8;
  }

  &.-has-error {
    > .title {
      @apply text-red-500;
    }

    > .title .errorMessage {
      text-transform: none;
      font-weight: normal;

      &:before {
        content: '- ';
      }
    }
  }
}
</style>
